import React, { useContext, useEffect, useState } from 'react';
import {
  ConformityContainer,
  ConformityInfo,
  ConformityInfoIcon,
  ConformityInfoIconWarning,
  ConformityFooter, ConformityModalDescriptionParagraph,
  ConformityModalDescriptionItemLabel,
  ConformityModalDescriptionItemContent
} from './styles';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import { P } from '../../../components/Typography/styles';
import { SecondaryLargeButton } from '../../../components/Buttons/styles';
import colors from '../../../assets/styles/colors';
import PdfView from '../../../components/PdfView';
import Loader from '../../../components/Loader';
import ModalAction from '../../../components/ModalAction';
import { useHistory, useLocation } from 'react-router-dom';
import { ClientRegistrationContext } from '../../../store';
import { getJuridicalProcess, notifcateClientWhenRuridicalProcessAreDone } from '../../../services/termsOfService';
import { conformityStatus } from '../../../helpers/enum';
import LoadingModal from '../../../components/ModalFlujoContinuo';
import ModalFlujoContinuoError from '../../../components/ModalFlujoContinuoError';
import validacionProspeccionErrorImg from '../../../assets/images/validacion-prospeccion.png';
import AlertaValidacionIdentidad from '../../../components/AlertaValidacionIdentidad';

const ConformityPage = ({ setActiveStep }) => {
  const history = useHistory();
  const location = useLocation();
  const { clientRegistration, setClientRegistration } = useContext(ClientRegistrationContext);
  const [scale, setScale] = useState(1.0);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [activeButton, setActiveButton] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState();
  const [pdf, setPdf] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [documents, setDocuments] = useState([]);
  const CREDIT_TIMER_KEY = 'creditTimers';
  const TIMER_DURATION = 5 * 60 * 1000;
  const [buttonText, setButtonText] = useState('Continuar');
  const [buttonDisabled, setIsButtonDisabled] = useState(false);
  const [remainingTime, setRemainingTime] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const LABELS = [
    "Verificando información",
    "Validacion riesgo",
    "Validacion riesgo",
    "Espera un momento..."
  ];
  const [showModalValidacionProspeccion, setShowModalValidacionProspeccion] = useState(false);

  async function onUpdateClientRegistration() {
    try {
      const timers = JSON.parse(localStorage.getItem(CREDIT_TIMER_KEY)) || {};
      const now = Date.now();
      const lastTimer = timers[clientRegistration.idCredito];
      const timeleft = TIMER_DURATION - (now - lastTimer);
      console.log(lastTimer)
      if ((!lastTimer) || timeleft <= 0) {
        if (clientRegistration.simulacion) {
          setIsLoading(true);
          setPageNumber(1);
          //setActiveButton(false);
          const data = {
            tipoIdentificacion: clientRegistration.cliente.tipoIdentificacion,
            identificacion: clientRegistration.cliente.identificacion,
            idAsesor: clientRegistration.simulacion.idAsesor,
            idCredito: clientRegistration.idCredito
          }
          const responseJuridicalProcess = await getJuridicalProcess(data);
          if (responseJuridicalProcess.data.estado !== conformityStatus[0].description) {
            setIsButtonDisabled(false);
            setButtonText('Volver a correr proceso');
          }
          if (responseJuridicalProcess.data.pdf === "") {
            setStatus(responseJuridicalProcess.data.estado);
            const data = {
              idCredito: location.idCredit,
              subCanal: "WEB"
            }

            const response = await notifcateClientWhenRuridicalProcessAreDone(data);

            setIsLoading(false);
            handleOpenModal();
            setDocuments(response.data);
          } else {
            setStatus(responseJuridicalProcess.data.estado);
            setPdf(responseJuridicalProcess.data.pdf);
          }
          setIsLoading(false);
        }
      } else {
        setRemainingTime(timeleft);
        if (timeleft > 0) {
          setButtonText(`Esperando: ${formatTime(timeleft)}`);
          setIsButtonDisabled(true);
        }

        setTimeout(() => {
          removeTimer(clientRegistration.idCredito);
        }, timeleft);
      }
    } catch (error) {
      console.log(error)
      setIsLoading(false);
    }
  }

  async function runAgain() {
    setIsLoading(true);
    setPageNumber(1);
    //setActiveButton(false);
    const data = {
      tipoIdentificacion: clientRegistration.cliente.tipoIdentificacion,
      identificacion: clientRegistration.cliente.identificacion,
      idAsesor: clientRegistration.simulacion.idAsesor,
      idCredito: clientRegistration.idCredito
    }
    const responseJuridicalProcess = await getJuridicalProcess(data);
    if (responseJuridicalProcess.data.estado !== conformityStatus[0].description) {
      initTimer(clientRegistration.idCredito);
    }
    if (responseJuridicalProcess.data.pdf === "") {
      setStatus(responseJuridicalProcess.data.estado);
      const data = {
        idCredito: location.idCredit,
        subCanal: "WEB"
      }

      const response = await notifcateClientWhenRuridicalProcessAreDone(data);

      setIsLoading(false);
      handleOpenModal();
      setDocuments(response.data);
    } else {
      setStatus(responseJuridicalProcess.data.estado);
      setPdf(responseJuridicalProcess.data.pdf);
    }
    setIsLoading(false);
  }

  function initTimer(idCredito) {
    const timers = JSON.parse(localStorage.getItem(CREDIT_TIMER_KEY)) || {};
    
    const now = Date.now();

    timers[idCredito] = now;
    localStorage.setItem(CREDIT_TIMER_KEY, JSON.stringify(timers));
    const timeleft = TIMER_DURATION - 0;
    setRemainingTime(timeleft);
  }

  function removeTimer(idCredito) {
    const timers = JSON.parse(localStorage.getItem(CREDIT_TIMER_KEY)) || {};
    delete timers[idCredito];
    localStorage.setItem(CREDIT_TIMER_KEY, JSON.stringify(timers));
  }

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    history.push({
      pathname: '/admin/data-solicitation',
      idCredit: location.idCredit,
      client:{
        id:clientRegistration.cliente.id,
        identification: clientRegistration.cliente.identificacion,
        identificationType: clientRegistration.cliente.tipoIdentificacion
      },
      step: 0
    })
  };

  useEffect(() => {
    if (status !== "COMPLETADO" && remainingTime > 0) {
      setButtonText(`Esperando: ${formatTime(remainingTime)}`);
      setIsButtonDisabled(true);


      // Reducir tiempo restante cada segundo
  
      // Reducir tiempo restante cada segundo
      const interval = setInterval(() => {
        setRemainingTime((prev) => {
          if (prev > 1000) {
            const newTime = prev - 1000;
            setButtonText(`Esperando: ${formatTime(newTime)}`);
            return newTime;
          } else {
            // Cuando el tiempo llega a 0, actualizamos y detenemos el intervalo
            clearInterval(interval);
            setButtonText("Volver a correr proceso");
            setIsButtonDisabled(false);
            return 0;
          }
        });
      }, 1000);
  
      return () => clearInterval(interval);
    }
  }, [status, remainingTime]); // Aquí mantenemos las dependencias necesarias


  function formatTime(ms) {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  }

  async function verifyProcess() {
    try {
      setIsLoading(true);
      if(status && status === conformityStatus[0].description) {
        const data = {
          idCredito: location.idCredit,
          subCanal: "WEB"
        }

        const response = await notifcateClientWhenRuridicalProcessAreDone(data);

        setIsLoading(false);
        handleOpenModal();
        setDocuments(response.data);
      } else {
        setIsLoading(false);
        runAgain();
      }
    } catch (error) {
      console.log(error.response)
      setIsLoading(false);
    }
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  useEffect(() => {
    if (status !== 'COMPLETADO') {
      onUpdateClientRegistration();
    }
  }, [clientRegistration])

  function moveToDashboard() {
    history.push({
      pathname: '/admin/dashboard/'
    });
  }

  /*useEffect(() => {
    if(pageNumber === numPages) {
      setActiveButton(true);
    }
  }, [pageNumber])*/

  return (
    <ConformityContainer>
      {isLoading ? <Loader /> : (
        <>
          <ConformityInfo>
            <ConformityInfoIcon background={status && status === conformityStatus[0].description}>
              {status && status === conformityStatus[0].description ? <BsCheck size={16} color={colors.white} /> : <BsExclamation size={16} color={colors.white} />}
            </ConformityInfoIcon>
            <P color={colors.textPrimary}>
              {status && status === conformityStatus[0].description ? 'Datos exitosamente consultados, en el siguiente documento los visualizas.' : 'Vuelve a correr el proceso a final de la página, algunos datos no fueron cargados, puedes revisar los datos faltantes resaltados en color rojo.'}
            </P>
          </ConformityInfo>
          <ConformityInfo>
            <ConformityInfoIconWarning>
              <BsExclamation size={16} color={colors.black} />
            </ConformityInfoIconWarning>
            <P color={colors.textPrimary}>
              Importante revisar la totalidad del documento mediante el botón tipo flecha costado derecho, para habilitar la opción de continuar.
            </P>
          </ConformityInfo>
          <PdfView
            pdf={pdf}
            pageNumber={pageNumber}
            scale={scale}
            numPages={numPages}
            onDocumentLoadSuccess={onDocumentLoadSuccess}
            setPageNumber={setPageNumber}
            setScale={setScale}
          />
          <ConformityFooter>
            <SecondaryLargeButton type="button" onClick={() => verifyProcess()} disabled={buttonDisabled}>{buttonText}</SecondaryLargeButton>
          </ConformityFooter>

          {/*<ModalAction
            open={showModal}
            setShowModal={setShowModal}
            actionFunctionUpButton={() => history.push({
              pathname: '/admin/global-debit',
              idCredit: location.idCredit,
              client: {
                id: clientRegistration.cliente.id,
                identification: clientRegistration.cliente.identificacion,
                identificationType: clientRegistration.cliente.tipoIdentificacion
              }
            })}
            title="La información del cliente ha sido validada exitosamente"
            description={(
              <div>
                <ConformityModalDescriptionParagraph>Ten presente los siguientes documentos para el proceso de radicación</ConformityModalDescriptionParagraph>
                {documents.map(item => (
                  <ConformityModalDescriptionItemContent>
                    <ConformityModalDescriptionItemLabel>{item.nombre}</ConformityModalDescriptionItemLabel>
                  </ConformityModalDescriptionItemContent>
                ))}
              </div>
            )}
            actionLabelFunctionUpButton="Continuar"
            backgroundIcon={colors.textHyperlink}
            bodyIcon={<BsCheck size={32} color={colors.white} />} />*/}
          <LoadingModal
            isOpen={isModalOpen}
            onClose={handleCloseModal}
            idCredito={location.idCredit}
            estadoEsperado='EN_REGISTRO_DATOS_ADICIONALES_CLIENTE'
            labels={LABELS}
            onError={() => setShowModalValidacionProspeccion(true)}
          />
          <ModalFlujoContinuoError
        title={<div>
          <b>Tu solicitud está en proceso de validación de prospección</b>
        </div>}
        description={<div>
          Una vez subsane, podrás continuar desde <u>"Pendientes por adjuntar" o "Pendientes por radicar"</u> según el resultado del análisis.
        </div>}
        open={showModalValidacionProspeccion} 
        setShowModal={setShowModalValidacionProspeccion}
        imgSource={validacionProspeccionErrorImg}
        onClose={moveToDashboard}
        />
          <ModalAction
            open={showModal}
            setShowModal={setShowModal}
            actionFunctionUpButton={() => history.push({ pathname: '/admin/dashboard' })}
            title="Solicitud se encuentra pendiente de validación"
            description={(<ConformityModalDescriptionParagraph>Consulta el estado del crédito en Pendientes por Radicar / Radicadas</ConformityModalDescriptionParagraph>)}
            actionLabelFunctionUpButton="Continuar"
            backgroundIcon={colors.textHyperlink}
            bodyIcon={<BsCheck size={32} color={colors.white} />} />
        </>
      )}
    </ConformityContainer>
  )
}

export default ConformityPage;
